import React from "react";
import classnames from "classnames";

const IconTags = props => {
    // metaKey = "hero." + propsicon.id + ".meta";
    // tagsKey = metaKey + ".tags";
    let { icon } = props;
    let { tags } = icon;

    if (!tags || !tags.length) {
        return null;
    }

    let tagsKey = "tags";
    tags = icon.tags.map(tag => {
        let url = "/term/" + tag.slug + "/";
        return (
            <li className="hero-tag" key={tagsKey + "." + tag.id}>
                <a href={url} title={tag.slug} className="text-link">
                    {tag.slug.split("-").join(" ")}
                </a>
            </li>
        );
    });

    return (
        <div className="related-searches">
            <span>Related Searches:</span>
            <ul className="icon-tags">{tags}</ul>
        </div>
    );
};
export default IconTags;
